// extracted by mini-css-extract-plugin
module.exports = {"Root":"ErrorFallback_Root__i1JCA","ErrorMessageAccordion":"ErrorFallback_ErrorMessageAccordion__sgUSo","ButtonWrapper":"ErrorFallback_ButtonWrapper__PXk_T"};